<template>
    <router-link :to="linkUrl" class="news-preview">
        <v-img v-if="imageUrl" :src="imageUrl" :aspect-ratio="1.6" class="news-preview__image" />
        <div v-else class="news-preview__placeholder">
            <v-icon size="48" color="secondary">mdi-newspaper-variant-outline</v-icon>
        </div>
        <div class="news-preview__body">
            <span class="news-preview__meta"
                >{{ category || 'Publicação' }}
                <span v-if="createdAt">· {{ $moment(createdAt).format('DD.MM.YYYY') }}</span></span
            >
            <h2>{{ title }}</h2>
            <p>{{ excerpt }}</p>
            <span class="news-preview__action"
                >Ler publicação
                <v-icon size="20" color="secondary">mdi-arrow-top-right</v-icon></span
            >
        </div>
    </router-link>
</template>
<script>
export default {
    name: 'NewsCard',
    props: {
        imageUrl: String,
        title: String,
        content: String,
        linkUrl: String,
        createdAt: String,
        category: String
    },
    computed: {
        excerpt() {
            const document = new DOMParser().parseFromString(this.content || '', 'text/html');
            return (document.body.textContent || '').replace(/\s+/g, ' ').trim();
        }
    }
};
</script>
<style scoped>
.news-preview {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #dedbd4;
    border-radius: 8px;
    background: #fff;
    color: var(--pbb-navy);
    text-decoration: none;
    transition: transform 220ms ease, border-color 220ms ease;
}
.news-preview:hover {
    transform: translateY(-4px);
    border-color: var(--pbb-copper);
}
.news-preview__placeholder {
    display: grid;
    place-items: center;
    aspect-ratio: 1.6;
    background: #eae6df;
}
.news-preview__body {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 26px;
}
.news-preview__meta {
    color: var(--pbb-muted);
    font-size: 11px;
    letter-spacing: 0.06em;
}
.news-preview h2 {
    margin: 16px 0;
    font: 500 23px/1.4 'Plus Jakarta Sans', sans-serif;
    letter-spacing: -0.03em;
}
.news-preview p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: var(--pbb-muted);
    font-size: 14px;
    line-height: 1.8;
}
.news-preview__action {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 24px;
    font-size: 12px;
    font-weight: 700;
}
@media (prefers-reduced-motion: reduce) {
    .news-preview {
        transition: none;
    }
    .news-preview:hover {
        transform: none;
    }
}
</style>
